unit Konstanten;

interface

Const

  c_Registry_Pfad   = 'Software\Fucosys' ;

  c_Bilder_Ordner   = '\Bilder' ;
  c_Report_Ordner   = '\Report' ;
  c_Profil_Ordner   = '\Profil' ;
  c_Archiv_Ordner   = '\Archiv' ;
//  c_Dokumente_Ordner = '\Dokumente';

  c_Sterne = '***';
  c_Alle   = '***';
  c_NeuAnl = '<neu anlegen>';
  c_ID_NeuAnl = -10;

  c_Komma = ',' ;
  c_Semikolon = ';';

  c_Mandant     = 'MANDANT';
  c_Formular    = 'FORMULAR';
  c_Abwesenheit = 'ABWESENHEIT';
  c_FzgAbwesenheit = 'FZG_ABWESENHEIT';
  c_Bst         = 'BESTELLUNG';
  c_LftGs       = 'GUTSCHRIFT_LFT';
  c_LftRng      = 'RECHNUNG_LFT';
  c_LftRngVrl   = 'LFT_RECHNUNG_VRL';
  c_LftAvis     = 'AVIS_LFT';
  c_Fahrzeug    = 'FAHRZEUG' ;
  c_FahrzeugLfz = 'FAHRZEUG_LFZ';
  c_Mitarbeiter = 'MITARBEITER';
  c_Bewerber    = 'BEWERBER';
  c_Lieferant   = 'LIEFERANT';
  c_Reparatur   = 'REPARATUR';
  c_Schaden     = 'SCHADEN';
  c_MaSchaden   = 'MA_SCHADEN';
  c_MaBeschZeit = 'MA_BESCHZEIT';
  c_MaBst       = 'MA_BST';
  c_MaMaterial  = 'MA_MATERIAL';
  c_MaBeleg     = 'MA_BELEG';
  c_MaInfo      = 'MA_INFO';
  c_MaLohnInfo  = 'MA_LOHNINFO';
  c_Lohndaten   = 'LOHNDATEN';
  c_Tankung     = 'TANKUNG';
  c_Tankkontrolle = 'TANKKONTROLLE';
  c_Spesensatz  = 'SPESENSATZ';
  c_Spesen      = 'SPESEN';
  c_Termin      = 'TERMIN';
  c_Reifen      = 'REIFEN';
  c_Kunde       = 'KUNDE';
  c_Interessent = 'INTERESSENT';
  c_Teil        = 'TEIL';
  c_Tau         = 'TRANSPORTAUFTRAG';
  c_TauKnd      = 'TAU_AN_KND';
  c_TauVorl     = 'TAU_VORL';
  c_TauLft      = 'TAU_AN_LFT';
  c_TauBeleg    = 'TAU_BELEG';
  c_TourBeleg   = 'TOUR_BELEG';
  c_Rau         = 'RAHMENAUFTRAG';
  c_Lfs         = 'TAU_LFS';
  c_Rng         = 'RECHNUNG';
  c_RngOrg      = 'RECHNUNG_ORG';
  c_RngDup      = 'RECHNUNG_DUP';
  c_RngVrl      = 'RECHNUNG_VRL';
  c_Kontakt     = 'KONTAKT';
  c_KorrRng     = 'KORR_RNG';
  c_Gutschrift  = 'GUTSCHRIFT';
  c_Mahnung     = 'MAHNUNG';
  c_RngUebKnd   = 'RECHNUNG_UEB';
  c_Frachtsatz  = 'FRACHTSATZ';
  c_TextilTarif = 'TEXTILTARIF';
  c_StundenSatz = 'STUNDENSATZ';
  c_StdSatzKnd  = 'STDSATZKND';
  c_LogWE       = 'LOGWE';
  c_LogWA       = 'LOGWA';
  c_FsKontrolle = 'FSKONTROLLE';
  c_AuswTaet    = 'AUSWTAET';

  c_UEbene1     = 'UEBENE1';
  c_UEbene2     = 'UEBENE1';

  c_KmSatz      = 'KILOMETERSATZ';
  c_Behoerde    = 'BEHOERDE';
  c_Tour        = 'TOUR';
  c_TourName    = 'TOURNAME';
  c_TourLinie   = 'TOURLINIE';
  c_GlobDaten   = 'GLOB_DATEN';
  c_Tourenplan  = 'TOURENPLAN';
  c_RngDuplikat = 'DUPLIKAT';
  c_LohnAbrg    = 'LOHNABRG';
  c_Verstoss    = 'VERSTOSS';
  c_KostErtr    = 'KOSTERTR';
  c_Ertrag      = 'ERTRAG';
  c_Angebot     = 'ANGEBOT';
  c_FilTE       = 'FILTE';
  c_FilTE_WA    = 'FILTE-WA';
  c_FilTE_TR    = 'FILTE-TR';
  c_Ang         = 'ANGEBOT';
  c_UebRahmen   = 'UEBRAHMEN';
  c_UebVertrag  = 'UEBVERTRAG';
  c_ArbVertrag  = 'ARBVERTRAG';
  c_PersDok     = 'PERSDOK';
  c_UebAbrg     = 'UEBABRG';
  c_Rollkarte   = 'ROLLKARTE';
  c_Kosten      = 'KOSTEN';
  c_KostenArt   = 'KOSTENART';
  c_Vertrag     = 'VERTRAG';
  c_Wau         = 'WERKSTATTAUFTRAG';
  c_WauArbKarte = 'WERKSTATTARBKARTE';
  c_Personalblatt = 'PERSONALBLATT';
  c_PalBwg    = 'PAL_BWG';
  c_AbfKon    = 'ABFKON';
  c_DPAuftrag = 'DP_AUFTRAG';
  c_DPKommentar = 'DP_KOMMENTAR';
  c_MaAufgabe = 'MA_AUFG';
  c_PPlanBem  = 'PPLAN_BEM';
  c_SchadenKarteFzg = 'SCHADENKARTE_FZG';
  c_SchadenKarteMab = 'SCHADENKARTE_MAB';
  c_PersNr = 'PERSNR';

  c_BusAng  = 'BUS_ANGEBOT';
  c_BusKau  = 'BUS_KAU';

  c_Post = 'POST';

  c_ReifenStandort = 'REIFEN_STANDORT';
  c_ReifenZustand  = 'REIFEN_ZUSTAND';

  c_Allg = 'ALLGEMEIN' ;


  // Nummerngenerator
  C_NGN_NNNN  = '<NNNN>';
  C_NGN_NNNNN = '<NNNNN>';
  C_NGN_NNNNNN= '<NNNNNN>';
  C_NGN_NNNNNNN= '<NNNNNNN>';
  C_NGN_NNNNNNNN= '<NNNNNNNN>';

  C_NGN_ZHL  = '<ZHL>';
  C_NGN_TEXT = '<TEXT>';
  C_NGN_JJ   = '<JJ>';
  C_NGN_JJJJ = '<JJJJ>';
  C_NGN_MM   = '<MM>';
  C_NGN_TT   = '<TT>';
  C_NGN_KW   = '<KW>';
  C_NGN_WT   = '<WT>';
  C_NGN_WTN  = '<WTN>';
  C_NGN_HH   = '<HH>';
  C_NGN_MN   = '<MN>';
  C_NGN_SS   = '<SS>';

  c_Ja   = 1;
  c_Nein = 0;

  c_Entf = -5;

  cH = chr(39);

  c_Enh_Stk = 14 ;

  c_SekAmTag = 86400;

  c_ImageDatenVorh = 60;

  cDatumZeit_Kurz = 'dd.mm.yy  hh:nn' ;

  c_Knz_Fzg = 1 ;
  c_Knz_Mab = 2 ;
  c_Knz_KndFzg = 3 ;
  c_Knz_Rau = 4;


  c_Kenn_Int = 1;
  c_Kenn_Knd = 2;

  c_AdrArt_Rng  = 'R';  // Rechnungsadresse
  c_AdrArt_Lfs  = 'L';  // Lieferadresse
  c_AdrArt_Bel  = 'B';  // Beladestelle
  c_AdrArt_Ent  = 'E';  // Entladestelle

  c_SteuerCode_Eink = 'EINK';
  c_SteuerCode_Verk = 'VERK';

  c_AdrArt_LfsAdr  = 'Lieferadresse' ;
  c_AdrArt_RngAdr  = 'Rechnungsadresse' ;
  c_AdrArt_Belade  = 'Beladestelle' ;
  c_AdrArt_Entlade = 'Entladestelle';

  c_MaOpt_Fahrer    = 1;
  c_MaOpt_Disponent = 2;
  c_MaOpt_Springer  = 3;
  c_MaOpt_Teilzeit  = 4;
  c_MaOpt_Werkstatt = 5;

  c_Out_Prev = 1;
  c_Out_Prnt = 2;
  c_Out_Mail = 3;
  c_Out_Pdf  = 4;
  c_Out_PdfToDoks = 5;  // PDF-Datei in Tabelle 'Dokumente' eintragen
  c_Out_XLS  = 10;

  c_Stati_PPlanBem   = 10;
  c_Stati_SchadenFzg = 20;
  c_Stati_SchadenMab = 30;
  c_Stati_MabBeleg   = 35;
  c_Stati_MabBst     = 38;
  c_Stati_LohnAbrg   = 40;
  c_Stati_RngKnd     = 50;
  c_Stati_RngLft     = 60;
  c_Stati_RngLftKorr = 65;
  c_Stati_LftGs      = 70;
  c_Stati_WauPrio    = 80;
  c_Stati_Bewerber   = 90;

  c_BP_DRK = 1 ;
  c_BP_PDF = 2 ;


  c_Prd_Teil = 'wird produziert';
  c_Enk_Teil = 'wird eingekauft';

  c_NeuerKunde = -234;
  c_NeuerLieferant = -236;
  c_NeuerTourname = -238;

  c_TeilTyp_Prd = 0;
  c_TeilTyp_Enk = 1;

  c_Filter       = 'Filter: '   ;
  c_Sortierung   = 'Sortierung: ' ;
  c_Leer         = '---'  ;

  c_ImageIndex_Druckvorschau = 43;
  c_ImageIndex_Drucken       = 12;

  c_TeilPreisEK = 1;
  c_TeilPreisVK = 2;

  c_Var_Datum = '%DATUM%';
  c_Var_Jahr  = '%JAHR%';
  c_Var_Monat = '%MONAT%';
  c_Var_Tag   = '%TAG%';
  c_Var_KM    = '%KM%';


  c_Symb_Fzg  = 'Fahrzeuge';
  c_Symb_Stm  = 'Stammdaten';
  c_Symb_Term = 'Termine';
  c_Symb_Kost = 'Kosten';
  c_Symb_Spes = 'Spesen';
  c_Symb_Disp = 'Disposition';
  c_Symb_Fakt = 'Faktura';
  c_Symb_Werk = 'Werkstatt';
  c_Symb_Fnst = 'Fenster';
  c_Symb_Fav  = 'Favoriten';

  c_DockedTo  = 'DockedTo';
  c_DockRow   = 'DockRow';
  c_DockPos   = 'DockPos';
  c_Left      = 'PosLeft';
  c_Top       = 'PosTop';
  c_Width     = 'Width';
  c_Visible   = 'Visible';
  c_Checked   = 'Checked';

  c_Act_Unternehmen =  5;
  c_Act_Fahrzeuge   = 10;
  c_Act_TermFzg     = 20;
  c_Act_TermMab     = 25;
  c_Act_Kosten      = 30;
  c_Act_Tankungen   = 40;
  c_Act_Reparaturen = 50;
  c_Act_Schaeden    = 55;
  c_Act_Mitarbeiter = 60;
  c_Act_Lieferanten = 65;
  c_Act_Kunden      = 70;


  // Fahrzeug-Status
  c_FzgStati_Aktiv    = 10;
  c_FzgStati_Inaktiv  = 20;
  c_FzgStati_Abgemld  = 30;
  c_FzgStati_Schrott  = 40;
  c_FzgStati_Verkauft = 50;
  c_FzgStati_Ruecklauf = 60;


  // Kennzeichen für Vorgangsart
  // im Kostengenerator
  //
  c_KostGenKnz_Vers   = 1 ;
  c_KostGenKnz_Steu   = 2 ;
  c_KostGenKnz_Leas   = 3 ;
  c_KostGenKnz_Afa    = 4 ;
  c_KostGenKnz_Miete  = 5 ;
  c_KostGenKnz_Finanz = 6 ;


  // Kennzeichen für Tabelle GLOB_DATEN
  //
  c_Glob_ReifenTyp  = 110;  // Reifen-Typen
  c_Glob_ReifenHrs  = 120;  // Reifen-Hersteller
  c_Glob_ReifenGrs  = 130;  // Reifen-Größen
  c_Glob_ReifenFlg  = 140;  // Reifen-Felgen
  c_Glob_Frankatur  = 410;  // Frankatur in Transportauftrag
  c_Glob_StornoGrund= 420;  // StornoGrund in Transportauftrag
  c_Glob_VerspGrund = 425;  // VerspätungsGrund in Transportauftrag
  c_Glob_TauArt     = 440;  // Transportauftrags-Art
  c_Glob_Standplatz = 450;  // Standplatz Fahrzeug
  c_Glob_TbsBer     = 470;  // Textbaustein-Bereiche
  c_Glob_Delikt     = 510;  // Verkehrsdelikte
  c_Glob_ErschwZul  = 520;  // Erschwerniszulagen für Mitarbeiter
  c_Glob_RngTyp     = 600;  // Rechnungstypen
  c_Glob_Kontaktart = 710;  // Kontaktarten in Kontakten
  c_Glob_SoTagTyp   = 720;  // SonderTags-Typ
  c_Glob_TomEreignisTyp = 740; // Ereignistypen aus TomTom
  c_Glob_PalTauschGrund = 760; // Palettentausch -Gründe- (HICU.DLL)




  // Kennzeichen für Achsen-Lage (FZG_ACHSEN)
  //
  c_AchLage_V = 10;  c_AchLage_V_Text = 'Vorne';
  c_AchLage_H = 30;  c_AchLage_H_Text = 'Hinten';
  c_AchLage_E = 80;  c_AchLage_E_Text = 'Ersatz';

  c_AchSeite_L = 10; c_AchSeite_L_Text = 'Links';
  c_AchSeite_R = 20; c_AchSeite_R_Text = 'Rechts';

  // Reifen-Standort
  //
  c_ReifStndOrt_ImWE     = 10; c_ReifStndOrt_ImWE_Txt     = 'Im Wareneingang';
  c_ReifStndOrt_ImLager  = 20; c_ReifStndOrt_ImLager_Txt  = 'Im Lager';
  c_ReifStndOrt_AmFzg    = 30; c_ReifStndOrt_AmFzg_Txt    = 'Am Fahrzeug';
  c_ReifStndOrt_Entsorgt = 90; c_ReifStndOrt_Entsorgt_Txt = 'Entsorgt' ;

  // Reifen-Zustand
  //
  c_ReifZustand_Neu       = 10; c_ReifZustand_Neu_Txt       = 'Neu';
  c_ReifZustand_Gebraucht = 30; c_ReifZustand_Gebraucht_Txt = 'Gebraucht';
  c_ReifZustand_Schrott   = 90; c_ReifZustand_Schrott_Txt   = 'Verschrottet';

  // TAU-Status
  c_Tau_Storniert  =  5;
  c_Tau_Angelegt   = 10;
  c_Tau_Disponiert = 20;
  c_Tau_Informiert = 25;
  c_Tau_Service    = 26;
  c_Tau_Beladen    = 28;
  c_Tau_Geliefert  = 30;
  c_Tau_LfsZurueck = 33;
  c_Tau_Bearbeitet = 35;
  c_Tau_Berechnet  = 40;

  // ANG-Status
  c_Ang_Angelegt     = 10;
  c_Ang_Angefragt    = 15;
  c_Ang_Gedruckt     = 20;
  c_Ang_Uebermittelt = 50;
  c_Ang_FertigOhneAU = 80;
  c_Ang_FertigMitAU  = 90;

  // BST-Status
  c_Bst_Angelegt      = 10;
  c_Bst_Uebermittelt  = 20;
  c_Bst_Bestaetigt    = 40;
  c_Bst_TeilGeliefert = 60;
  c_Bst_Geliefert     = 80;

  // BusKAU-Status
  c_BusKau_Storniert  =  5;
  c_BusKau_Angelegt   = 10;
  c_BusKau_Disponiert = 20;
  c_BusKau_Bearbeitet = 35;
  c_BusKau_Berechnet  = 40;


  // WAU-Status
  c_Wau_Angelegt      = 10;
  c_Wau_Freigegeben   = 20;
  c_Wau_InBearbeitung = 30;
  c_Wau_Fertig        = 40;

  c_WauTyp_FzgInt = 0;
  c_WauTyp_FzgExt = 1;
  c_WauTyp_WBInt  = 2;

  // FilTE
  c_FilTE_Angelegt  = 10;
  c_FilTE_FehltImWE = 20;
  c_FilTE_ImWE      = 30;
  c_FilTE_Transit   = 40;
  c_FilTE_ImWA      = 50;
  c_FilTE_FehltImWA = 60;
  c_FilTE_Versendet = 70;
  c_FilTE_Storniert = 90;

  c_UebAbrg_Angelegt  = 10;
  c_UebAbrg_ZuBerech  = 20;
  c_UebAbrg_Berechnet = 30;

  c_DispoArt_Fzg = 1;  // Fahrzeug
  c_DispoArt_TN  = 2;  // Tourname
  c_DispoArt_Fah = 3;  // Fahrer

  c_TpFo1_FzgKw  = 1;
  c_TpFo2_TnKw   = 2;
  c_TpFo3_TnTg   = 3;
  c_TpFo4_FzgTg  = 4;
  c_TpFo5_FzgNTg = 5;
  c_TpFo5_FzgNTg2D = 6;
  c_TpFo7_FahNTg = 7;

  c_DokTyp_MaVertrag  = 10;
  c_DokTyp_UebVertrag = 20;

  c_Imp_Esso    = 100;
  c_Imp_JET     = 200;
  c_Imp_Shell   = 300;
  c_Imp_Aral    = 400;
  c_Imp_SVG     = 500;
  c_Imp_Domesle = 600;
  c_Imp_AS24    = 700;
  c_Imp_Westf   = 710;  // Westfehling
  c_Imp_EDC     = 720;
  c_Imp_TP24    = 730;
  c_Imp_UTA     = 740;
  c_Imp_UTAMaut = 741;
  c_Imp_Dachser = 750;
  c_Imp_RKW     = 760;
  c_Imp_DKV     = 770;
  c_Imp_Fip     = 778;
  c_Imp_Bachsteffel = 779;
  c_Imp_Planzer    = 780;
  c_Imp_Leimgruber = 781;
  c_Imp_AutoPoll = 782;
  c_Imp_Westfalen = 783;
  c_Imp_IDS     = 784;
  c_Imp_Leibold = 785;
  c_Imp_Total   = 786;
  c_Imp_Hoyer   = 787;
  c_Imp_Varo    = 788;
  c_Imp_EuroWag = 789;
  c_Imp_TeamEnergie  = 790;
  c_Imp_WestfalenXLS = 791;
  c_Imp_Schenker = 792;
  c_Imp_BischoffVielhauer = 793;
  c_Imp_Avia = 794;
  c_Imp_ENI = 795;
  c_Imp_BayWa = 796;

  c_Imp_TomTom        = 800;
  c_Imp_TL_KmLeistung = 801;
  c_Imp_FB_MoDaten    = 802;
  c_Imp_Rent_KmDaten  = 803;
  c_Imp_RioEinsatzdaten = 804;

  c_ImpMa_TachoNova = 100;
  c_ImpMa_TachoPlus = 110;
  c_ImpMa_Tacholog  = 120;
  c_ImpMa_StzPersKost = 130;



  // Beladestelle-Knz
  //
  c_Belade_Knz_BeiKnd1 = 'Beladung beim Kunde';
  c_Belade_Knz_Divers2 = 'Beladestelle divers';
  c_Belade_Knz_BeiUns3 = 'Beladung bei uns';

  // Entladestelle-Knz
  //
  c_Entlade_Knz_BeiKnd1 = 'Entladung beim Kunde';
  c_Entlade_Knz_Divers2 = 'Entladestelle divers';
  c_Entlade_Knz_BeiUns3 = 'Entladung bei uns';

  c_TauPosFeld_Ladestellen  = '[Ladestellen]';
  c_TauPosFeld_Packstuecke  = '[Packstücke]';
  c_TauPosFeld_Frachtpreis  = '[Frachtpreis]';
  c_TauPosFeld_Zusatzkosten = '[Zusatzkosten]';
  c_TauPosFeld_RngText      = '[Rng-Text]';

  c_Leerzeile = '[Leerzeile]';

  c_PKtoArt_Knd   = 10;
  c_PKtoArt_Lft   = 20;
  c_PKtoArt_Sonst = 90;

  // NumGen - Reset-Invervall
  //
  c_NumGen_Tag  = 10;
  c_NumGen_Wo   = 20;
  c_NumGen_Mo   = 30;
  c_NumGen_Jahr = 40;

  c_Dok_Vrg_NurVerkn    = 'L';  // Link
  c_Dok_Vrg_Kopieren    = 'C';  // Copy
  c_Dok_Vrg_Verschieben = 'M';  // Move
  c_Dok_Vrg_AnwFragen   = 'Q';  // Question

  c_Anw = 1 ;
  c_Abw = 2 ;

  c_Feiertag = -5;
  c_Urlaub   = -10;
  c_UrlaubH  = -9;
  c_Krank    =   1;
  

  c_FreiSam = 'ABW_FREI_SA';
  c_FreiSon = 'ABW_FREI_SO';
  c_FT_Bundesland = 'FT_VON_BUNDESLAND';

  c_FuRio     = 'FuRio.DLL' ;
  c_FuEinkauf = 'FuEinkauf.DLL' ;
  c_FuVerkauf = 'FuVerkauf.DLL' ;
  c_FuReifen  = 'FuReifen.DLL' ;
  c_FuMaut    = 'FuMaut.DLL';
  c_FuImport  = 'FuImport.DLL';
  c_FuTankImp = 'FuTankImp.DLL';
  c_FuRngExp  = 'FuRngExp.DLL';
  c_FuErtrag  = 'FuErtrag.DLL';
  c_FuLohn    = 'FuLohn.DLL';
  c_FuUmsch   = 'FuUmsch.DLL';
  c_FuAngebot = 'FuAngebot.DLL';
  c_FuTomTom  = 'FuTomTom.DLL';
  c_FuZeit    = 'FuZeit.DLL';
  c_FuPep     = 'FuPep.DLL';
  c_FuZeitarbeit = 'FuZeitarbeit.DLL';
  c_FuPersonal   = 'FuPersonal.DLL';
  c_FuLager      = 'FuLager.DLL';
  c_FuKosten     = 'FuKosten.DLL';
  c_FuWau        = 'FuWau.DLL';
  c_FuPaletten   = 'FuPaletten.DLL';
  c_FuTelematik  = 'FuTelematik.DLL';
  c_FuTelematik2 = 'FuTelematik2.DLL';
  c_FuMobil      = 'FuMobil.DLL';
  c_FuReport     = 'FuReport.DLL';
  c_FuBus         = 'FuBus.DLL';

  c_FuHiCu       = 'FuHiCu.DLL';
  c_FuBono       = 'FuBono.DLL';
  c_FuSitzmann   = 'FuSitzmann.DLL';
  c_FuPost       = 'FuPost.DLL';
  c_FuDHL        = 'FuDHL.DLL';

  c_Mail_Bereich_DHL = 200;

  WM_TOURSTATUS_UPD = $0400 + 1;
  WM_NEW_MOBIL_MSG =  $0400 + 2;

  c_FuService    = 'FuService';
  c_FuServiceCmd = 'FuServiceCmd';

implementation

end.


